import axios from 'axios'
import * as AxiosLogger from 'axios-logger'

const logConfig = {
  prefixText: 'API:OAuth',
}

const instance = axios.create({
  baseURL: process.env.REACT_APP_PORTAALI_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
})

if (process.env.NODE_ENV === 'development') {
  instance.interceptors.request.use(
    (request) => AxiosLogger.requestLogger(request, logConfig),
    (err) => AxiosLogger.errorLogger(err, logConfig)
  )
  instance.interceptors.response.use(
    (response) => AxiosLogger.responseLogger(response, logConfig),
    (err) => AxiosLogger.errorLogger(err, logConfig)
  )
}

export const setAuthorization = (token) => {
  instance.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

export const getUsers = (filter) =>
  instance.post('/oAuth/list', {
    text: filter.text,
    page: filter.page,
    column: filter.column,
    sortDirection: filter.sortDirection,
    paginationPerPage: filter.paginationPerPage,
  })

export const findUser = (uid) => instance.post('/oAuth/find', { uid })

export const upsertUsers = (list) => instance.post('/oAuth/upsert', { list })

export const deleteUsers = (list) => instance.post('/oAuth/delete', { list })
